// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9850714f","389":"cf23e74f","732":"f048b43c","977":"82d25e65"}[chunkId] + ".chunk.js";
};